export default "__VITE_ASSET__Bapz$sZ9__"